// removed by extract-text-webpack-plugin
module.exports = {"button":"s6v4D"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-social-actions/post-social-actions.scss
// module id = 1713
// module chunks = 0